import styled from 'styled-components';

type WrapperProps = {
    showHeader?: boolean;
};

export const Wrapper = styled.div<WrapperProps>`
    padding: 0 20px 20px 20px;
    max-width: ${({ showHeader }) => (showHeader ? '80%' : '100%')};
    margin: 0 auto;

    @media screen and (max-width: 769px) {
        max-width: 100%;
    }
`;

export const Hr = styled.div`
    width: 100%;
    height: 0px;
    border: 1px solid #e7e7f0;
    margin-bottom: 20px;
    transform: translateX(-20px);
`;

export const Header = styled.header`
    display: flex;
    align-items: center;
    margin-bottom: 8px;
`;

export const HeaderTextWrapper = styled.div`
    margin-left: 8px;
`;

export const HeaderText = styled.h3`
    font-size: 24px;
    font-weight: 600;
    color: #333;
    margin: 0;
`;

export const HeaderIcon = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const MainCard = styled.div`
    background: white;
    border-radius: 12px;
    padding: 24px;
    margin-top: 16px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
    display: flex;
    flex-direction: column;
    gap: 24px;
    border: 1px solid rgba(0, 0, 0, 0.1);
`;

export const DateRangeContainer = styled.div`
    display: flex;
    gap: 16px;
    align-items: flex-start;
    flex-wrap: wrap;

    @media screen and (max-width: 769px) {
        flex-direction: column;
    }
`;

export const DateField = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 8px;
    width: 100%;
`;

export const DateLabel = styled.label`
    font-size: 14px;
    color: #666;
    font-weight: 500;
`;

export const DateInputWrapper = styled.div`
    padding: 12px;
    background: white;
    display: flex;
    align-items: center;
    gap: 8px;
    cursor: pointer;
    min-height: 44px;

    &:hover {
        border-color: #ccc;
    }

    /* Override calendar component styles */
    .calendar-input {
        border: none;
        background: transparent;
        padding: 0;
        font-size: 14px;
        color: #333;
        flex: 1;
    }

    .calendar-icon {
        color: #666;
    }
`;

export const GroupByContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
`;

export const GroupByLabel = styled.label`
    font-size: 14px;
    color: #666;
    font-weight: 500;
`;

export const GroupByInputWrapper = styled.div`
    border: 1px solid #e0e0e0;
    border-radius: 8px;
    padding: 12px;
    background: white;
    display: flex;
    align-items: center;
    gap: 8px;
    cursor: pointer;
    min-height: 44px;

    &:hover {
        border-color: #ccc;
    }
`;

export const GroupByIcon = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const GroupByText = styled.span`
    flex: 1;
    font-size: 14px;
    color: #333;
`;

export const DropdownIcon = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const GenerateButtonWrapper = styled.div`
    display: flex;
    justify-content: flex-end;
    margin-top: 8px;
`;

export const ButtonIcon = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 8px;
`;

export const GenerateButton = styled.button`
    background: #34a853;
    color: white;
    border: none;
    border-radius: 8px;
    padding: 12px 24px;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: background-color 0.2s ease;

    &:hover {
        background: #16a34a;
    }

    &:disabled {
        background: #9ca3af;
        cursor: not-allowed;
    }
`;

export const CommisionFilterWrapper = styled.div`
    margin-top: 12px;
    display: flex;
`;

export const DropDownBox = styled.div<{ is_mobile: boolean }>`
    width: 100%;
    display: flex;
    flex-direction: ${(props) => (props.is_mobile ? 'row' : 'column')};
    margin: 10px 0;
    ${(props) =>
        props.is_mobile
            ? 'justify-content: space-around;'
            : 'align-items:center;'}
`;

export const CalendarWrapper = styled.div`
    margin: 10px 0;
    @media screen and (max-width: 769px) {
        max-width: 180px;

        margin: 0;
    }
`;

export const ErrorText = styled.p`
    font-size: 12px;
    line-height: 16px;
    margin-top: 4px;
    color: rgb(216, 61, 55);
`;

export const ListingWrapper = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;
`;

export const LoaderBox = styled.div`
    height: '100%';
    display: 'grid';
    place-items: 'center';
`;

export const ButtonWrapper = styled.footer`
    width: 100%;
    display: flex;
    gap: 10px;
`;
export const FilterOptionButtonWrapper = styled.button`
    display: flex;
    align-items: center;
    justify-content: space-around;
    border: none;
    background: transparent;
`;

// New styled components for Group By filter
export const GroupByBoxesContainer = styled.div`
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 12px;
    margin-top: 8px;
`;

export const GroupByBox = styled.div<{ isSelected: boolean }>`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 16px 12px;
    border: 1px solid ${(props) => (props.isSelected ? '#8b5cf6' : '#e0e0e0')};
    border-radius: 12px;
    background: ${(props) => (props.isSelected ? '#8b5cf6' : 'white')};
    cursor: pointer;
    transition: all 0.2s ease;
    min-height: 80px;

    &:hover {
        border-color: ${(props) => (props.isSelected ? '#8b5cf6' : '#ccc')};
    }
`;

export const BoxIcon = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 8px;
`;

export const BoxText = styled.span<{ isSelected: boolean }>`
    font-size: 14px;
    font-weight: 500;
    color: ${(props) => (props.isSelected ? 'white' : '#333')};
    text-align: center;
`;

export const GroupByDropdownContainer = styled.div`
    position: relative;
`;

export const DropdownMenu = styled.div`
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    background: white;
    border: 1px solid #e0e0e0;
    border-radius: 8px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    z-index: 1000;
    margin-top: 4px;
    max-height: 300px;
    overflow-y: auto;
`;

export const DropdownItem = styled.div<{ isSelected: boolean }>`
    display: flex;
    align-items: center;
    padding: 12px 16px;
    cursor: pointer;
    background: ${(props) => (props.isSelected ? '#f3f4f6' : 'white')};
    transition: background-color 0.2s ease;

    &:hover {
        background: #f9fafb;
    }

    &:first-child {
        border-radius: 8px 8px 0 0;
    }

    &:last-child {
        border-radius: 0 0 8px 8px;
    }
`;

export const DropdownItemIcon = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 12px;
`;

export const DropdownItemText = styled.span`
    flex: 1;
    font-size: 14px;
    color: #333;
`;

export const DropdownCheckIcon = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: 8px;
`;

export const NavigationTabs = styled.div`
    display: flex;
    background-color: #f3f4f6;
    border-radius: 8px;
    padding: 4px;
    width: fit-content;
    margin: 32px auto;

    @media screen and (max-width: 769px) {
        width: 100%;
    }
`;

export const Tab = styled.button<{ isActive: boolean }>`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    padding: 8px;
    width: 200px;
    background: ${(props) => (props.isActive ? 'white' : '#f3f4f6')};
    border: none;
    color: ${(props) => (props.isActive ? '#374151' : '#6b7280')};
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    border-radius: 8px;
    position: relative;
    transition: all 0.2s ease;
`;

export const TabIcon = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const Badge = styled.span`
    background: #8b5cf6;
    color: white;
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 10px;
    font-weight: 500;
    padding: 2px;
`;

// Report History styled components
export const ReportHistoryContainer = styled.div`
    background: white;
    border-radius: 12px;
    padding: 24px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
    border: 1px solid rgba(0, 0, 0, 0.1);
`;

export const ReportHistoryHeader = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 24px;
`;

export const ReportHistoryTitle = styled.h3`
    font-size: 20px;
    font-weight: 600;
    color: #1f2937;
    margin: 0;
`;

export const ReportHistoryCount = styled.span`
    font-size: 14px;
    color: #6b7280;
    font-weight: 500;
`;

export const ReportHistoryList = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
`;

export const ReportHeader = styled.div`
    display: flex;
    align-items: center;
    gap: 20px;
    width: 100%;
`;

export const ReportHistoryItem = styled.div<{ isLoading?: boolean }>`
    display: flex;
    align-items: flex-start;
    padding: 20px;
    border: 1px solid #e5e7eb;
    border-radius: 12px;
    transition: all 0.2s ease;
    position: relative;
    margin-bottom: 16px;
    opacity: ${(props) => (props.isLoading ? 0.5 : 1)};
    pointer-events: ${(props) => (props.isLoading ? 'none' : 'auto')};

    @media screen and (max-width: 769px) {
        flex-direction: column;
        gap: 16px;
        align-items: stretch;
    }
`;

export const ReportStatus = styled.span<{
    isComplete: boolean;
    isFailed: boolean;
}>`
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 10px;
    font-weight: 500;
    color: ${(props) =>
        props.isComplete
            ? '#059669'
            : props?.isFailed
            ? 'rgb(216, 61, 55)'
            : '#3b82f6'};
    background: ${(props) =>
        props.isComplete
            ? '#d1fae5'
            : props?.isFailed
            ? 'rgb(255 228 227)'
            : '#dbeafe'};
    padding: 4px 10px;
    border-radius: 12px;
    white-space: nowrap;
`;

export const StatusIcon = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const ReportDetails = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 6px;
    min-width: 0;
`;

export const ReportTitle = styled.h4`
    font-size: 14px;
    font-weight: 600;
    color: #1f2937;
    margin: 0;
`;

export const ReportData = styled.span`
    font-size: 12px;
    color: rgb(115, 115, 115);
    font-weight: 400;
`;

export const ReportCreated = styled.span`
    font-size: 12px;
    color: #9ca3af;
    font-weight: 400;
    margin-top: 4px;
`;

export const ReportInfoText = styled.span`
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 12px;
    color: rgb(115, 115, 115);
    font-weight: 400;
    margin-top: 8px;
`;

export const ProgressContainer = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
`;

export const ProgressBar = styled.div`
    flex: 1;
    height: 6px;
    background: #e5e7eb;
    border-radius: 3px;
    overflow: hidden;
    width: 100%;
`;

export const ProgressFill = styled.div<{ progress: number }>`
    height: 100%;
    background: #3b82f6;
    width: ${(props) => props.progress}%;
    transition: width 0.3s ease;
    border-radius: 3px;
`;

export const ReportActions = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    margin-left: 16px;
    margin: 0;
`;

export const ActionButton = styled.button`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 36px;
    height: 36px;
    border: 1px solid #e5e7eb;
    border-radius: 8px;
    background: white;
    cursor: pointer;
    transition: all 0.2s ease;

    &:hover {
        border-color: #d1d5db;
        background: #f9fafb;
        transform: translateY(-1px);
    }

    &:active {
        transform: translateY(0);
    }
`;

export const RetryButton = styled.button`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 4px;
    border: unset;
    background: #3b82f6;
    color: white;
    font-size: 12px;
    border-radius: 6px;
    padding: 4px 8px;
    cursor: pointer;

    &:hover {
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
    }
`;

export const SecondaryFiltersWrapper = styled.div``;

export const SecondaryFiltersHeaderText = styled.div`
    font-size: 14px;
    color: #666;
    font-weight: 500;
`;

export const SecondaryFiltersContainer = styled.div`
    display: grid;
    grid-template-columns: 1fr;
    margin-top: 8px;
    gap: 12px;
    border: 1px solid #e0e0e0;
    border-radius: 8px;
    padding: 12px;
    background: white;
    max-height: 200px;
    overflow: scroll;

    @media (min-width: 768px) {
        grid-template-columns: 1fr 1fr 1fr 1fr;
    }
`;

export const SecondaryFilter = styled.div`
    display: flex;
    align-items: center;
    text-transform: capitalize;
    font-size: 14px;
    gap: 4px;
    color: #333;
`;

export const NoResult = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    color: #666;
`;

export const SearchWrapper = styled.div`
    margin: 8px 0;
    max-width: 50%;

    @media screen and (max-width: 768px) {
        max-width: 100%;
    }
`;
